import "core-js/modules/es.array.index-of";
//
//
//
//
//
//
//
//
//
import overview from '../../pages/config/overview';
import setting from '@/setting';
import user from '@/store/modules/d2admin/modules/user';
export default {
  components: {
    overview: overview
  },
  data: function data() {
    return {
      title: setting.projectName
    };
  },
  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},
  methods: {
    isOverView: function isOverView() {
      var userRules = user.state.info.rules_ids;

      if (userRules.indexOf(184) >= 0) {
        return true;
      }

      return false;
    }
  }
};